import $ from 'jquery';
import Navigation from '../components/Navigation';

function toggleSearch(e) {
  if ($('.search-toggle-button').hasClass('open') && $(e.target).hasClass('search-browse-parent-outline')) {
    $('.search-toggle-button').removeClass('open');
  } else {
    $('.search-browse-container').css({ top: $('.search-browse-parent-outline').height() });
    $('.search-toggle-button').addClass('open');
  }
}

function fireSearchSelect(e) {
  const $target = $(e.target);
  if ($target.val().length) {
    window.location = $target.val();
  }
}

export default class StaticHeader {
  constructor(section) {
    this.$el = $(section.el);
    this.data = section.data;
    this.navigation = new Navigation({ el: this.$el });
    this._bindEvents();
  }


  _bindEvents() {
    this.events = [
      $('.search-toggle-button', this.$el).on('click.header', e => toggleSearch(e)),
      $('.shop-by-category', this.$el).on('change.header', e => fireSearchSelect(e)),
      $(document.body).on('click.header', (e) => {
        if (!$(e.target).closest('.search-toggle-button').length) {
          $('.search-toggle-button').removeClass('open');
        }
      }),
    ];
  }

  _unbindEvents() {
    if (this.events) {
      this.events.forEach(event => event.off('.header'));
    }
  }

  prepareRemove() {
    this._unbindEvents();
  }
}
